module.exports = __webpack_public_path__ + "img/home_icon_9.cbeef90b.png";